export const inputSubtext =
    'Remember, I am generative AI and I am still learning.\nPlease do not include confidential or personal information and always verify the information I give to you for accuracy. My use is strictly subject to the';

export const defaultPlaceholder = 'Ask follow-up...';
